import React from 'react';
import useConversationsList from '@/widget/ui/hooks/useConversationsList';
import ListHeader from '@/widget/ui/components/conversations/ListHeader';
import ListItem from '../ListItem';
import styles from './List.module.scss';

function List() {
  const { conversations, openConversation } = useConversationsList();

  return (
    <div className={styles.container}>
      <ListHeader />
      <div className={styles.conversationsContainer}>
        {conversations && conversations.map((conversation) => (
          <div className={styles.conversation}>
            <ListItem
              key={conversation.key}
              conversation={conversation}
              openConversation={openConversation}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default List;
